<template>
  <div class="history_box">
    <el-row :gutter="10" v-if='resetAble'>
      <el-col :span="12" v-for="(item, index) in fenceList" :key="index + 'history'">
        <el-checkbox v-model="value[item.id+'']" @change="change" :disabled='item.select' border>
          <span>{{item.fenceJson && item.fenceJson.text}}</span><br>
          <span>{{item.fenceJson && item.fenceJson.range + '米'}}</span>
        </el-checkbox>
        <span :class="'delete ' + (item.select ? 'disabled' : '')" @click.stop="deleteHandle(item.select, item.id)" >删除</span>
      </el-col>
      <el-col style="padding-left: 20px;" v-show='fenceList && fenceList.length <= 0'>暂无历史创建地点</el-col>
    </el-row>
  </div>
</template>
<script>
import {mapState, mapActions} from 'vuex'
import { Message } from 'element-ui'

export default {
  name: 'SelectCitys',
  props: ['disAbleData', 'resetAble'],
  computed: {
    ...mapState('fenceData', [
      'Count',
      'deleteSuc',
      'fenceList'
    ])
  },
  data () {
    return {
      value: {}
    }
  },
  watch: {
    deleteSuc: function (params) {
      if (params.id) {
        // console.log('params.id', params.id)
        this.requestData()
      }
    },
    resetAble: function (params) {
      // console.log('resetAble', params)
      this.handleDisAble()
      // this.$forceUpdate()
      if (!params) { // 重置数据
        this.value = {}
      }
    },
    fenceList: function (params) {
      this.handleDisAble()
    }
  },
  mounted () {
    this.requestData()
  },
  updated () {

  },
  methods: {
    requestData (v) {
      this.getFenceList()
    },
    handleDisAble: function () {
      // console.log('resetAble===>>>', this.resetAble)
      // console.log('disAbleData=====>>>', this.disAbleData)
      // console.log('value=====>>>', this.value)
      this.resetAble && this.fenceList.map((v, i) => {
        v.select = false
        this.disAbleData[this.disAbleData.selectFlag].map((id, index) => {
          if (id === v.id) {
            v.select = true
            this.value[id + ''] = true
          }
        })
      })
    },
    change (v) {
      let data = []
      // let able = false
      // let valueKeys = Object.keys(this.value)

      // let counter = 0
      // valueKeys.map((v, i) => {
      //   this.value[v] && counter++
      // })
      // if (counter >= 3) {
      //   able = true
      // }

      this.fenceList.map((v, i) => {
        if (this.value[v.id + ''] && !v.select) {
          data.push(v)
        // } else if (!this.value[v.id + ''] && able) {
        //   // 如果选择了3个地点 那么禁用其他的
        //   v.select = true
        // } else {
        //   v.select = false
        }
      })

      this.$emit('historyAddressHandle', data)
    },
    deleteHandle (selected, fenceid) {
      if (selected) return null

      // 如果已经在外面的出发地或者目的地选择了该地点， 则不让删除，message提示
      let flag = this.disAbleData.selectFlag === 'addresssStart' ? 'addresssEnd' : 'addresssStart'
      let deleteAble = true
      this.disAbleData[flag].map((id, index) => {
        if (id === fenceid) {
          deleteAble = false
          Message({
            message: '您已将该地点选为' + (flag === 'addresssStart' ? '出发地' : '目的地') + '，暂不可删除。',
            type: 'warning',
            center: true
          })
        }
      })

      // 如果已选择该地点 则采取模拟点击穿透的效果 不让删除
      if (this.value[fenceid]) {
        this.value[fenceid] = false
        return
      }

      deleteAble && this.deleteFence({fenceId: fenceid})
    },
    ...mapActions('fenceData', [
      'deleteFence',
      'getFenceList'
    ])
  }
}

</script>
<style lang='stylus'>
  .history_box
    .el-checkbox__label
      vertical-align: middle;
      width: 100%;
      padding-right: 50px;
      box-sizing: border-box;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    .el-checkbox.is-bordered
      height:60px;
      width: 100%;
      margin-bottom: 10px;
    .el-col-12
      position relative;
    .delete
      position: absolute;
      top: 10px;
      right: 20px;
      color: #3468ff;
      cursor: pointer;
    .delete.disabled
      color: #c0c4cc;
</style>
